
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    section: Object,
  },
})
export default class ArticleSection extends Vue {}
